import GrupoController from "@/shared/controllers/grupo/grupoController";
import UsuarioController from "@/shared/controllers/usuario/usuarioController";

const name = 'AdicionarGrupo'
export default {
  name,

  components: { }, 

  props: { },

  mounted () {

    if(this.$route.params.id != "")
    {
      this.getEdicaoGrupo();
    }
  },

  updated () { },

  data () {
    return { 
      Colunas: [
        {field: 'nome', header: 'Usuario'},
        {field: 'email', header: 'Email'},
      ],
      UsuariosVinculados: [],
      UsuarioArray: [],
      UsuarioArrayGrid: [],
      UsuarioTudo:null,
      UsuarioLiderId: null,
      UsuarioId:null,
      NomeGrupo:null
    }
  },

  methods: { 

    editar(){
      let dataParaOBack = {
        NomeGrupo: this.NomeGrupo,
        UsuarioLiderId: this.UsuarioLiderId,
        Id: this.$route.params.id,
        UsuariosVinculados: this.UsuariosVinculados
      }

      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + `Grupos/EditarGrupo`,
        data: dataParaOBack
      })
        .then((response) => {
          this.$isLoading(false)

          if(response.data.data != null)
          {
            this.$toast.add({ severity: 'success', summary: 'Grupo Editado', detail: 'Grupo editado com sucesso!', life: 7000 });
          }
          else{
            this.$toast.add({ severity: 'error', summary: 'Erro ao Editar Grupo', detail: 'Erros ao editar o grupo!', life: 7000 });
          }
        })
        .catch(() => {
        });
    },
    
    getEdicaoGrupo(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Grupos/GetGrupoById/${this.$route.params.id}`,
      })
        .then((response) => {
        this.NomeGrupo = response.data.data.nomeGrupo
        this.UsuarioLiderId = response.data.data.usuarioLiderId
        this.getUsuariosLideres()


        this.GetUsuariosVinculadosAoGrupoById()
        })
        .catch(() => {
        });
    },

    getUsuariosLideres() {
      GrupoController.getUsuariosLideres().requisicao
      .then((res => {
        this.UsuarioArray = res.data.data
      }))
    },
    VerificaQuantidadeGrupoPorUsuario(data) {
  
      GrupoController.VerificaQuantidadeGrupoPorUsuario(data.Id).requisicao
      .then((res => {
        let grupoUnico = res.data.data;

        if(grupoUnico != false) {
          this.excluir(data)
        } else {
          this.$toast.add({ severity: 'error', summary: 'Não é possível excluir esse usuário pois ele não possui nenhum outro grupo vinculado', life: 5000 });
        }
        }))
     },
    GetUsuariosVinculadosAoGrupoById() {
      GrupoController.GetUsuariosVinculadosAoGrupoById(this.$route.params.id).requisicao
      .then((res => {
        res.data.data.forEach(e => {
          let variavel = {"Id": e.id, "nome":e.nome, "email": e.email }
          this.UsuariosVinculados.push(variavel)
        });
        
      }))
    },
    gravar(){

      if(this.$route.params.id == "")
      {
        let dataParaOBack = {
          NomeGrupo: this.NomeGrupo,
          UsuarioLiderId: this.UsuarioLiderId,
          UsuariosVinculados: this.UsuariosVinculados
        }
  
        this.axios({
          method: 'post',
          url: process.env.VUE_APP_WEB_API + `Grupos/SalvarGrupo`,
          data: dataParaOBack
        })
          .then((response) => {
            this.$isLoading(false)

            if(response.data.data != null)
            {
              this.$toast.add({ severity: 'success', summary: 'Grupo Criado', detail: 'Grupo criado com sucesso!', life: 7000 });
              this.NomeGrupo = null
              this.UsuarioLiderId = null
              this.UsuariosVinculados = []
            }
            else{
              this.$toast.add({ severity: 'error', summary: 'Erro ao Criar Grupo', detail: 'Grupo já existe!', life: 7000 });
            }
          })
          .catch(() => {
          });
      }
      else{
        this.editar()
      }
    },
    buscarUsuario(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        UsuarioController.getUsuarios(event).requisicao
        .then((res => {
          this.UsuarioArray = res.data.data
        }))
      }, 1000);
    },

    buscarUsuarioGrid(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        UsuarioController.getUsuarios(event).requisicao
        .then((res => {
          this.UsuarioArrayGrid = res.data.data
        }))
      }, 1000);
    },

    excluir(data) {
      let dataEmString = JSON.stringify(data)
      this.UsuariosVinculados = this.UsuariosVinculados.filter(e => JSON.stringify(e) != dataEmString)
    },

    AdicionarUsuarioAoGrid(){
      UsuarioController.GetAllById(this.UsuarioId).requisicao
      .then((res => {
        this.UsuarioTudo = res.data.data
        
        let variavel = {"Id": this.UsuarioId, "nome":this.UsuarioTudo.nome, "email": this.UsuarioTudo.email }
        
        this.UsuariosVinculados.push(variavel)
                   
        this.UsuarioId = null
        }))
    },
  },

  computed: { }, 

};